import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { getToken } from './auth';
import { queryClient } from '../apiQuery/queryClient';

const WRITE_METHODS = ['post', 'put', 'patch', 'delete'];

export const baseUrlImg = "https://storage.googleapis.com/erpcloud-bucket";

const api: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API,
  timeout: parseInt(process.env.REACT_APP_API_TIMEOUT || '300000'), // 5 minutos em milissegundos
  maxContentLength: parseInt(process.env.REACT_APP_MAX_BODY_SIZE || '52428800'), // 50MB
  maxBodyLength: parseInt(process.env.REACT_APP_MAX_BODY_SIZE || '52428800'), // 50MB
});



// Interceptador para adicionar token de autorização e X-Store ao cabeçalho da requisição
api.interceptors.request.use((config: any) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
    config.headers['X-Store'] = localStorage.getItem('X-Store');
  }
  return config;
});

// Interceptador para lidar com erros de resposta
api.interceptors.response.use(
  (response) => {
    const token = getToken();

    if (token) {
      response.headers['Authorization'] = `Bearer ${token}`;
    }

    // Qualquer gravação bem-sucedida invalida todo o cache: as telas abertas
    // recarregam na hora e as demais buscam de novo ao serem abertas.
    if (WRITE_METHODS.includes((response.config.method || '').toLowerCase())) {
      queryClient.invalidateQueries();
    }

    return response;
  },
  (error) => {
    if (error.response) {
      return Promise.reject({
        status: error.response.status,
        message: error.response.data.message || error.response.data.error,
        details: error.response.data.errors,
      });
    } else {
      return Promise.reject(error);
    }
  }
);

export default api;
